import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 480);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-4 z-40 flex h-10 w-10 cursor-pointer items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-colors hover:bg-primary-600 md:right-8"
    >
      <i className="ri-arrow-up-line text-lg leading-none" aria-hidden="true" />
    </button>
  );
}